import { StyledButton } from 'src/components/atoms/Button/Button.styles';
import { IconButton } from 'src/components/atoms/IconButton';
import styled from 'styled-components';

export const PaginationStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const CustomDisabledIcon = styled(IconButton)`
  height: 28px;
  width: 28px;
  margin-right: 4px;
  border: none;
  &:disabled {
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.default};
    cursor: default;
  }
`;

export const EllipsisIcon = styled(IconButton)`
  margin-right: 4px;
  height: 28px;
  width: 28px;
  &:disabled {
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.surface.default};
    border: none;
    cursor: default;
    i {
      color: ${(props) => props.theme.atlas.semantic.color.type.default};
    }
  }
`;
export const PageButton = styled(StyledButton)<{ pageNumber: number }>`
  padding: 6px 10px;
  width: ${(props) => (props.pageNumber <= 9 ? '28px' : '')};
  min-width: unset;
  height: 28px;
  margin-right: 4px;
  &:active {
    border: 1px solid
      ${(props) => props.theme.atlas.semantic.color.outline.default};
  }
`;
